/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-11 09:19:19
 * @LastEditors: susj
 * @LastEditTime: 2020-10-20 17:03:02
 */
import Vue from 'vue';
import Vuex from 'vuex';
// Vuex 模块
// import router from './modules/router';
import common from './common';
import schemeEditStore from './schemeEdit';
import schemeList from './modules/list';

import undoRedoPlugin from './plugins/undo-redo/index';
import editor from './modules/editor';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    schemeEditStore,
    schemeList,
    editor,
  },
  ...common,
  plugins: [undoRedoPlugin],
});
